module.exports = __webpack_public_path__ + "static/media/av3.a7cb3ab4.JPG";